import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "right" }
const _hoisted_5 = { class: "form-info" }
const _hoisted_6 = { class: "code-box" }
const _hoisted_7 = { class: "save-box" }
const _hoisted_8 = { class: "agreement" }

import { watch, ref, reactive, h } from "vue";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import api from "@/services/index";
import { siteId } from "@/services/config";
import loginTip from "@/assets/login_tip.png";
import { useRouter, useRoute } from "vue-router";
import routerTree from "@/router/config";
import userInfoStore from "@/store/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const userStore = userInfoStore();
const formRef = ref();
const router = useRouter();
const countdown = ref(0);
const userAgree = ref(false);
const isCountingDown = ref(false);
let timer: any = null;

const form = reactive({
  phone: "",
  code: "",
});
const validatePhone = async (_, value: string) => {
  const phoneReg = /^1[3-9]\d{9}$/;
  if (!value) {
    throw new Error("请输入手机号码");
  }
  if (!phoneReg.test(value)) {
    throw new Error("手机号格式不正确");
  }
};
const rules = reactive({
  phone: [
    { required: true, message: "请输入手机号码", trigger: "blur" },
    { validator: validatePhone, trigger: "blur" },
  ],
  code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
});

// 检查手机号是否有效，这里简单判断长度
const canGetCode = ref(false);

watch(
  () => form.phone,
  () => {
    // 监听手机号变化
    console.log("监听手机号变化");
    canGetCode.value = form.phone.length === 11;
  }
);

// 获取验证码
const getVerificationCode = async () => {
  if (!form.phone) {
    ElMessage.warning("请输入手机号码");
    return;
  }
  if (!/^1[3-9]\d{9}$/.test(form.phone)) {
    ElMessage.warning("请输入正确的手机号码");
    return;
  }
  const params = {
    phone: form.phone,
    siteId,
  };
  const res = await api.login.sendCode(params);
  if (res.status == 200) {
    ElMessage({
      message: "发送验证码成功 ",
      type: "success",
    });
    // 开始倒计时
    isCountingDown.value = true;
    countdown.value = 60;
    timer = setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0) {
        clearInterval(timer);
        isCountingDown.value = false;
      }
    }, 1000);
    return;
  }
  ElMessage({
    message: "发送验证码失败 ",
    type: "error",
  });
};

//返回主页
const backHome = () => {
  //router.push(routerTree.home);
  window.location.href = "https://www.stdaily.com";
};
//获取用户个人信息
const getUserInfo = async () => {
  try {
    const res = await api.login.getUserInfo({});
    if (res.status == 200) {
      localStorage.setItem("userInfo", JSON.stringify(res.obj));
      userStore.isLogin = true;
      userStore.userInfo = res.obj;
    }
  } catch (err) {
    console.log("err", err);
  }
};
//登录
const loginHandle = async (formRef: FormInstance) => {
  if (userAgree.value == false) {
    ElMessage({
      message: "请先勾选《科技日报》用户协议！",
      type: "warning",
    });
    return;
  }
  if (!formRef) return;
  formRef.validate(async (valid) => {
    if (valid) {
      const params = {
        phone: form.phone,
        code: form.code,
        siteId,
      };
      const res = await api.login.phoneLogin(params);
      if (res.status == 200) {
        //将token存在本地
        localStorage.setItem("token", res.obj.accessToken);

        ElMessage({
          message: res.msg,
          type: "success",
        });
        getUserInfo();
        setTimeout(() => {
          router.push(routerTree.home);
        }, 1000);

        return;
      }
      ElMessage({
        message: res.msg,
        type: "error",
      });
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: _unref(loginTip) }, null, 8, _hoisted_3),
      _createVNode(_component_el_button, {
        class: "btn",
        onClick: backHome
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { color: "#ffffff" }, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowLeft)
            ]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" 返回首页"))
        ]),
        _: 1,
        __: [4]
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "login-welcome" }, "欢迎登录！", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "120px",
          "label-position": "top",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "手机号码",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.phone,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.phone) = $event)),
                  placeholder: "请输入手机号码",
                  maxlength: "11",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "验证码",
              prop: "code"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_input, {
                    modelValue: form.code,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.code) = $event)),
                    placeholder: "请输入验证码"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    class: "code-btn",
                    disabled: isCountingDown.value || !canGetCode.value,
                    onClick: getVerificationCode
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(countdown.value > 0 ? `${countdown.value}秒后重新获取` : "获取验证码"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_button, {
          class: "btn",
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (loginHandle(formRef.value)))
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createTextVNode("立即登录")
          ])),
          _: 1,
          __: [5]
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_checkbox, {
          modelValue: userAgree.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((userAgree).value = $event)),
          size: "large"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [
            _createTextVNode("同意 "),
            _createElementVNode("a", {
              href: "https://kejiribao.testnewmedia.xinhuaapp.com/html/user_agreement_xcx.html\n          ",
              target: "_blank"
            }, "《科技日报》用户协议", -1)
          ])),
          _: 1,
          __: [6]
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})